import { LEEWAY_DURATION } from "../constants";
import { diffIn } from "./date-helper";
export const getLeewayDuration = () => LEEWAY_DURATION;
export const getBufferDuration = (duration) => {
    if (duration >= 900)
        return 20;
    if (duration >= 300)
        return 15;
    return 10;
};
export const getMatchStartedAt = (match, moves) => {
    const matchStartedAt = match.startedAt || match.createdAt;
    // FIXME: This is to prevent bugs where match.startedAt is updated after a move has been performed
    const firstMove = moves.length >= 1 ? moves.at(0) : null;
    if (firstMove && firstMove.createdAt < matchStartedAt) {
        return firstMove.createdAt;
    }
    return matchStartedAt;
};
export const getCommencedAt = (match, moves) => {
    const commencedMove = match.tournamentId
        ? moves.length >= 1
            ? moves.at(0)
            : null
        : moves.length >= 2
            ? moves.at(1)
            : null;
    return match.commencedAt || commencedMove?.createdAt;
};
export const hasCommenced = (match, moves) => {
    const leewayDuration = getLeewayDuration();
    const commencedByMoveCount = match.tournamentId
        ? moves?.length >= 1
        : moves?.length >= 2;
    const commencedByTime = match.tournamentId
        ? diffIn(new Date(), match.startedAt, "second") >= leewayDuration
        : false;
    return !!match.commencedAt || commencedByMoveCount || commencedByTime;
};
export const hasCommencedByMoveCount = (match, moves) => {
    return match.tournamentId ? moves?.length >= 1 : moves?.length >= 2;
};
